import { render, staticRenderFns } from "./TabProposalTechnical.vue?vue&type=template&id=7473f318&scoped=true&"
import script from "./TabProposalTechnical.vue?vue&type=script&lang=js&"
export * from "./TabProposalTechnical.vue?vue&type=script&lang=js&"
import style0 from "./TabProposalTechnical.vue?vue&type=style&index=0&id=7473f318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473f318",
  null
  
)

export default component.exports